/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { TextField } from "@mui/material";
import useErrors from "../../Utils/userErrors";
import ErrorText from "../ErrorText";
import withTooltip from "../HOC/withTooltip";
import TextInputModel from "./TextInputModel";
import TextInputProps from "./TextInputProps";

export default withTooltip(function TextInput(props: TextInputProps) {
    const { error, errorTexts, clearErrorsOnChange } = useErrors(props);
    const vm = new TextInputModel(props);
    return (
        <TextField
            className="lan-textinput-clarity"
            type={vm.type}
            placeholder={vm.placeholder}
            inputProps={props.inputProps}
            InputProps={{
                ...vm.InputProps,
                readOnly: !!vm.readonly,
                inputRef: props.inputRef
            }}
            InputLabelProps={{ shrink: true }}
            label={vm.caption}
            value={vm.value ?? ""}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            onChange={clearErrorsOnChange(vm.aendern)}
            name={vm.name}
            disabled={!!vm.readonly}
            autoFocus={vm.autoFocus}
            error={error}
            helperText={<ErrorText errors={errorTexts} />}
            required={vm.required}
            maxRows={vm.rowsMax}
            {...(props.rows !== undefined ? { rows: props.rows, multiline: true } : {})}
            {...(props.multiline !== undefined ? { multiline: props.multiline } : {})}
            variant={props.variant ?? "outlined"}
            margin={props.margin ?? "dense"}
            size="small"
            fullWidth
            autoComplete="off"
            sx={props.sx}
        />
    );
});
